<script lang="ts">
    import { inview } from "svelte-inview"
    import type { ObserverEventDetails, Options } from "svelte-inview"

    let isInView = false

    export let options: Options = {
        rootMargin: "150px",
        unobserveOnEnter: true,
    }

    function handleChange(e: CustomEvent<ObserverEventDetails>) {
        isInView = e.detail.inView
    }
</script>

<fragment use:inview="{options}" on:inview_change="{handleChange}" data-in-view="{'test_' + JSON.stringify(isInView)}">
    {#if isInView}
        <slot />
    {:else}
        <slot name="not-in-view" />
    {/if}
</fragment>
